/**
 * listAdminDirectory Callable の React Query ラッパ。
 * 仕様書: docs/02_work/done/plan_board_feature.md §5-1
 *
 * admins コレクションは owner 以外 read 不可のため、内部メンバーの
 * ディレクトリ（宛先ピッカー・名前解決用の最小フィールド）は Callable 経由で取得する。
 * 外部SA (level==='external') はサーバ側で拒否され、返却値にも含まれない。
 */
import type { DepartmentId, Level } from '@goenhub/shared';
import { useQuery } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';

import { functions } from '@/lib/firebase';

// listAdminDirectory (functions/src/board/directory.ts) の wire フォーマットに合わせる。
// displayName は '' 合体で常に string、dept/level は未設定 doc で null になりうる。
export interface AdminDirectoryMember {
  uid: string;
  displayName: string;
  fullName: string | null;
  photoUrl: string | null;
  dept: DepartmentId | null;
  level: Level | null;
}

const listAdminDirectoryFn = httpsCallable<
  Record<string, never>,
  { members: AdminDirectoryMember[] }
>(functions, 'listAdminDirectory');

export function useAdminDirectory() {
  return useQuery({
    queryKey: ['adminDirectory'],
    // メンバー構成は頻繁に変わらないため長めにキャッシュ
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<AdminDirectoryMember[]> => {
      const res = await listAdminDirectoryFn({});
      return res.data.members;
    },
  });
}
